<template>
  <div class="homeview-main">
    <ProductItem
      v-for="(item, index) in productList"
      :data-id="item.offerId"
      key="index"
      :item="item"
      @on-click="onItemClick"
    />
    <H5LoadMore />
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import H5LoadMore from './components/H5LoadMore/index.vue'
import { ProductItem } from '@/components/ProductItem'
import { buriedPointUtil, gaAnalytics, openURLWithChannelQuery, throttle } from '@/utils/utils'

const store = useStore()

const props = defineProps({
  module: {
    type: String,
    default: null
  }
})

const productList = computed(() => store.state.productList)

onMounted(async () => {
  await nextTick() // 确保 DOM 已完全渲染

  /**
   * TODO: 硬代码，防止 图搜页 重复触发埋点相关操作
   */
  if (props.module === 'similar') return
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const offerId = entry.target.dataset.id
        observerIdList.value.add(offerId)
        reportExposure()
      }
    })
  }, { threshold: 0.5 })
})

const lastPageSize = ref(0)
watch(productList, (value, oldValue) => {
  if (value && value.length > 0) {
    productExposure()
    lastPageSize.value = value.length - oldValue.length
  }
})

const observer = ref(null)
const observerIdList = ref(new Set()) // 正在观察的 offerId 列表
const reportedOfferIdList = ref([]) // 已报告的 offerId 列表
const productExposure = () => {
  setTimeout(() => {
    document.querySelectorAll('.product-item').forEach(product => {
      observer.value.observe(product)
    })
  }, 500)
}

const reportExposure = throttle(() => {
  const offerIdList = []
  observerIdList.value.forEach(id => {
    if (reportedOfferIdList.value.indexOf(id) === -1) {
      offerIdList.push(id)
      reportedOfferIdList.value.push(id) // 添加到已报告的列表中
    }
  })

  if (offerIdList.length > 0) {
    buriedPointUtil({ eventId: 'MPEX101', others: { offerIdList } })
    preSearch()
  }
}, 500)

const preSearch = () => {
  const reportedCount = observerIdList.value.size // 已曝光商品总数

  const half = Math.floor(lastPageSize.value / 2)
  const point = productList.value.length - half
  if (reportedCount >= point) {
    store.commit('search/SET_PRE_SEARCH', true)
  }
}

defineExpose({
  reportedOfferIdList
})

const onItemClick = (item) => {
  gaAnalytics('mp_home_product_click', 'mp_home_product_click', { spuId: item.offerId })
  buriedPointUtil({ eventId: 'MPHM203', spuId: item.offerId, recExt: item.ext })

  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}&adding=${btoa(item.addingCount)}`)
}
</script>

<style>
.homeview-main {
  padding: 0px 16px;
  margin-top: 16px;
  display: grid;
  gap: 16px 13px;
  position: relative;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}
</style>
